import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BriefcaseIcon, GraduationCapIcon, LayersIcon, Sparkles } from 'lucide-react';
import { Eyebrow, Section } from '../ui/Section';
const items = [{
  icon: BriefcaseIcon,
  title: 'Clientas a diario',
  text: 'Diagnóstico rápido y certero en cada servicio.',
  isNew: false
}, {
  icon: LayersIcon,
  title: 'Estudio o domicilio',
  text: 'Con tu maletín de siempre alcanza.',
  isNew: false
}, {
  icon: GraduationCapIcon,
  title: 'Querés dar clases',
  text: 'Posicionate como especialista en colorimetría.',
  isNew: true
}, {
  icon: Sparkles,
  title: 'Casos difíciles',
  text: 'Piel madura, acné, tonos claros y oscuros.',
  isNew: false
}];
export function ForWhom() {
  return <Section className="bg-cream" data-id="element-112" data-mp="1ob6ma8eaf112">
      <div className="mx-auto max-w-2xl text-center" data-id="element-113" data-mp="1o80ycwhea56x">
        <Eyebrow data-id="element-114" data-mp="1abx8tghgul0s">¿Para quién es?</Eyebrow>
        <h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:mt-3 sm:text-4xl" data-id="element-115" data-mp="1acymlspv9lm7">
          Llevá tu criterio de color al próximo nivel
        </h2>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-2.5 sm:mt-10 sm:gap-5" data-id="element-116" data-mp="r9x4cn2vazdm">
        {items.map(({
        icon: Icon,
        title,
        text,
        isNew
      }, index) => <motion.div key={title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        delay: index * 0.06
      }} className="relative rounded-xl bg-white p-3.5 shadow-sm ring-1 ring-rosegold/10 sm:flex sm:gap-4 sm:rounded-2xl sm:p-6" data-id="element-117" data-mp="1090mnou7nar2" data-mpi={index}>
            {isNew && <span className="absolute right-2 top-2 rounded-full bg-rosegold px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-white sm:right-4 sm:top-4 sm:px-2.5 sm:text-[10px]" data-id="element-118" data-mp="ha68oi2kmeby">Nuevo</span>}
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-blush text-rosegold sm:h-12 sm:w-12 sm:shrink-0 sm:rounded-xl" data-id="element-119" data-mp="3kxy54othsusf">
              <Icon className="h-4 w-4 sm:h-6 sm:w-6" strokeWidth={1.6} data-id="element-120" data-mp="3fxk77zllv184" />
            </div>
            <div data-id="element-121" data-mp="1jw8dvav1lwuh">
              <h3 className="mt-2 font-display text-base font-semibold leading-tight text-ink sm:mt-0 sm:text-xl" data-id="element-122" data-mp="1juntuf6ctwav">{title}</h3>
              <p className="mt-1 text-[11px] leading-snug text-plum sm:mt-1.5 sm:text-sm sm:leading-relaxed" data-id="element-123" data-mp="1tmjpzkovrccg">{text}</p>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-6 text-center sm:mt-10" data-id="element-124" data-mp="10xmb7rjvnxog">
        <a href="#garantia" className="inline-flex items-center gap-1.5 text-xs font-semibold text-rosegold underline-offset-4 hover:underline sm:gap-2 sm:text-sm" data-id="element-125" data-mp="10yxqanirwruv">
          ¿No estás segura? Tenés 7 días de garantía <ArrowRightIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" data-id="element-126" data-mp="1au8vof8akmpy" />
        </a>
      </div>
    </Section>;
}